<template>
  <div>

  </div>
</template>

<script>
import mixins from '../mixins/detail';

export default {
  name: 'defaultDetail',
  mixins: [mixins],
  data() {
    return {
      warningTipText: '',
    };
  },
  created() {},
  mounted() { },
  methods: {
    render() {
    },
  },
};
</script>

<style scoped lang="less">
.text {
  color: @app-color-up;
}
</style>
